import { render, staticRenderFns } from "./ChatGroupDropdown.vue?vue&type=template&id=faddc12a&scoped=true&"
import script from "./ChatGroupDropdown.vue?vue&type=script&lang=js&"
export * from "./ChatGroupDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ChatGroupDropdown.vue?vue&type=style&index=0&id=faddc12a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faddc12a",
  null
  
)

export default component.exports